class KsFancySlideshow extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector('.swiper');
    if (!this.sliderElement) return;

    this.swiperJsPath = this.dataset.vendorJsFile;

    this.init();
  }

  async init() {
    try {
      await this.loadVendorScript();
      this.initSwiper();
      this.initScrollAnimation();

      if (Shopify.designMode) {
        this.initEditorListeners();
      }
    } catch (error) {
      console.error('Fancy Slideshow Error:', error);
    }
  }

  loadVendorScript() {
    if (window.Swiper) {
      return Promise.resolve();
    }

    return this.loadScript(this.swiperJsPath, 'swiper-js');
  }

  initSwiper() {
    const isDesignMode = Shopify.designMode;

    const autoplay =
      this.sliderElement.dataset.swiperAutoplay === '0'
        ? false
        : {
            delay: Number(this.sliderElement.dataset.swiperAutoplay) * 1000,
            disableOnInteraction: false,
          };

    this.swiper = new window.Swiper(this.sliderElement, {
      navigation: {
        enabled: this.sliderElement.dataset.swiperNavigation === 'true',
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      pagination: {
        enabled: ['bullets', 'fraction'].includes(this.sliderElement.dataset.swiperPagination),
        el: '.swiper-pagination',
        type: this.sliderElement.dataset.swiperPagination,
      },
      scrollbar: {
        enabled: this.sliderElement.dataset.swiperPagination === 'scrollbar',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      effect: this.sliderElement.dataset.swiperEffect,
      speed: Number(this.sliderElement.dataset.swiperSpeed || 300),
      autoplay: isDesignMode ? false : autoplay,
      breakpoints: {
        0: {
          slidesPerView: this.sliderElement.dataset.swiperPartial === 'true' ? 1.4 : 1,
          spaceBetween:
            this.sliderElement.dataset.swiperSpacing === 'true'
              ? Number(this.sliderElement.dataset.swiperSpacingMobile)
              : 0,
        },
        750: {
          slidesPerView: this.sliderElement.dataset.swiperPartial === 'true' ? 1.3 : 1,
          spaceBetween:
            this.sliderElement.dataset.swiperSpacing === 'true'
              ? Number(this.sliderElement.dataset.swiperSpacingDesktop)
              : 0,
        },
        990: {
          slidesPerView: this.sliderElement.dataset.swiperPartial === 'true' ? 1.2 : 1,
          spaceBetween:
            this.sliderElement.dataset.swiperSpacing === 'true'
              ? Number(this.sliderElement.dataset.swiperSpacingDesktop)
              : 0,
        },
      },
      creativeEffect: {
        prev: { translate: [0, 0, -400] },
        next: { translate: ['100%', 0, 0] },
      },
      centeredSlides: true,
      loop: !isDesignMode,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
    });
  }

  initScrollAnimation() {
    const mediaWrappers = this.querySelectorAll('.ks-media-wrapper');
    if (mediaWrappers.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { intersectionRatio } = entry;
          mediaWrappers.forEach((elem) => {
            const targetOpacity = Number(elem.dataset.overlayOpacity);
            const finalOpacity = 100 - intersectionRatio * (100 - targetOpacity);
            elem.style.setProperty('--overlay-opacity', `${finalOpacity}%`);
          });
        });
      },
      {
        threshold: Array.from(Array(101).keys()).map((i) => i / 100),
      }
    );

    observer.observe(this);
  }

  initEditorListeners() {
    this.addEventListener('shopify:block:select', (event) => {
      if (this.swiper) {
        const slideIndex = parseInt(event.target.closest('.swiper-slide').dataset.index, 10);
        const realIndex = this.swiper.slides.findIndex(
          (slide) => slide.dataset.index == slideIndex && !slide.classList.contains('swiper-slide-duplicate')
        );
        if (realIndex > -1) this.swiper.slideTo(realIndex);
      }
    });
  }

  loadScript(src, id) {
    return new Promise((resolve, reject) => {
      if (document.getElementById(id)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.id = id;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}

if (!customElements.get('ks-fancy-slideshow')) {
  customElements.define('ks-fancy-slideshow', KsFancySlideshow);
}